import api from '../api';
import { batchUpdateStock } from '../api';

export async function saveAllStocks(updates, sellerId) {
  return batchUpdateStock(updates, sellerId);
}
